export const COOKIE_KEY = {
  COUNTRY: 'country',
  LANGUAGE: 'language',
  CURRENCY: 'currency',
  API_TOKEN: 'apiToken',
  THEME_MODE: 'themeMode',
};

export const COOKIE_DEFAULT_VALUE = {
  [COOKIE_KEY.COUNTRY]: 'SG',
  [COOKIE_KEY.LANGUAGE]: 'en',
  [COOKIE_KEY.CURRENCY]: 'SGD',
  [COOKIE_KEY.API_TOKEN]: null,
  [COOKIE_KEY.THEME_MODE]: 'light',
};
